import React, { useEffect, useState, useCallback } from "react"
import { Link, useParams } from "react-router-dom"

import Page from "./Page"
import ReportPurchaseDetail from "../components/ReportPurchaseDetail"

import { getReportGroup } from "../api"

export function getLatestRun(report) {
    const latestRun = report?.ReportRuns?.sort((a, b) => new Date(b.runDate).getTime() - new Date(a.runDate).getTime())[0]
    return latestRun
}


export function getLatestRunDate(report) {
    const latestRun = report?.ReportRuns?.sort((a, b) => new Date(b.runDate).getTime() - new Date(a.runDate).getTime())[0]
    return latestRun?.runDate
}

export function formatLatestRunDateForReport(report) {
    return formatRunDate(getLatestRunDate(report))
}

export function formatRunDate(runDateOrUndefined) {
    const dateText = runDateOrUndefined ? new Date(runDateOrUndefined).toLocaleDateString() : ""
    return dateText
}

export function formatLatestRunDateTimeForReport(report) {
    return formatRunDateTime(getLatestRunDate(report))
}

export function formatRunDateTime(runDateOrUndefined) {
    const dateText = runDateOrUndefined ? new Date(runDateOrUndefined).toLocaleString() : ""
    return dateText
}

export function getLatestDownloadUrlForReport(report) {
    return getUrlForReportRun(report?.id, report?.ReportRuns[0])
}

export function getUrlForReportRun(reportId, reportRun) {
    return ((reportId) && (reportRun?.id) && (reportRun.status==='complete')) ? `/api/report/${reportId}/pdf/${reportRun.id}` : ''
}

export function getLogUrlForReportRun(reportId, reportRun) {
    return ((reportId) && (reportRun?.id)) ? `/api/report/${reportId}/log/${reportRun.id}` : ''
}

function isRunInProgressForAnyReportInGroup(reportGroup) {
    return reportGroup.Reports.find((report) => report.ReportRuns.find((run) => run.status === 'in progress'))
}

export default function ReportGroupViewPage() {
    const { reportGroupId } = useParams()

    const [reportGroup, setReportGroup] = useState()
    const [loadError, setLoadError] = useState()
    const [refreshTimer, setRefreshTimer] = useState()

    const loadReportGroup = useCallback(function () {
        setLoadError('')
        getReportGroup(reportGroupId).then(setReportGroup).catch((err) => {
            setLoadError(err.message)
        })
    }, [reportGroupId])

    useEffect(loadReportGroup, [loadReportGroup, refreshTimer])

    useEffect(() => {
        if (!reportGroup) return 
        const runInProgress = isRunInProgressForAnyReportInGroup(reportGroup)
        if (runInProgress) {
            let timeoutId = setTimeout(() => {
                setRefreshTimer(Date.now())
            }, 2000)
            return () => clearTimeout(timeoutId)
        }
    }, [reportGroup])

    const loading = (!reportGroup && !loadError)
    
    return (
        <Page title="AERAS - Report Batch">
            {loading && <i>Loading....</i>}
            {reportGroup && (
                <div className="row mt-2">
                    <div className="col mb-2">
                        <h2 className="me-4">{reportGroup.groupName}</h2>
                        {/* <button className="btn btn-secondary float-end"><i className="bi-map me-2"></i>Map</button> */}
                        <small className="text-body-secondary">Prepared for</small>
                        <div className="ms-4 mb-2">
                            <h6 className="mb-0">{reportGroup.Reports[0].contactName}</h6>
                            <small>{reportGroup.Reports[0].email}</small>
                        </div>
                        <div className="ms-4 mb-2">
                            <h6 className="mb-0">{reportGroup.Reports[0].companyName}</h6>
                            {reportGroup.Reports[0].address} <br />
                            {reportGroup.Reports[0].city} {reportGroup.Reports[0].province} {reportGroup.Reports[0].postalCode}
                        </div>
                        <div className="mb-2">
                            <div className="d-flex">
                                <small className="me-auto text-body-secondary">Created at</small>
                            </div>
                            <div className="ms-4">{formatRunDateTime(reportGroup.createdAt)}</div>
                        </div>
                    </div>
                    <table className="table">
                        <thead>
                            <tr>
                                <th className="h6">Name</th>
                                <th className="h6">Location</th>
                                <th className="h6">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportGroup.Reports.map((report, index) => (
                                <tr key={index}>
                                    <td><Link to={`/report/${report.id}`}>{report.projectName}</Link></td>
                                    <td>{report.quarterSections}</td>
                                    <td>
                                        { getLatestRun(report)?.status === 'failed' && (
                                            <div className="text-danger">Failed</div>                                                        
                                        )}
                                        { getLatestRun(report)?.status === 'error' && (
                                            <div className="text-danger">Error - <a className="text-danger" href={getLogUrlForReportRun(report.id, run)} download>Log<i className="bi-download ms-2"></i></a></div>                                                        
                                        )}
                                        { getLatestRun(report)?.status === 'in progress' && (
                                            <div className="text-warning">In progress<div className="ms-1 spinner-border spinner-border-sm"></div></div>                                                        
                                        )}
                                        { getLatestRun(report)?.status === 'complete' && (
                                            <a href={getUrlForReportRun(report.id, getLatestRun(report))} download>Download<i className="bi-download ms-2"></i></a>
                                        )}                                    
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    { loadError && (
                        <div className="ms-2 text-danger">{loadError}</div>
                    )}
                    <ReportPurchaseDetail report={reportGroup.Reports[0]} reloadReport={loadReportGroup}/>
                </div>
            )}
        </Page>
    )
}